import { Flex, Popover } from 'antd';
import React from 'react';

import { TaskBoardTaskAssignee } from '../taskBoard/component/taskBoardTaskAssignee';

export interface ListAssigneeWithAvatarProps {
    listIdAssignee: string[];
}

const ListAssigneeWithAvatar: React.FC<ListAssigneeWithAvatarProps> = ({ listIdAssignee }) => {
    const COUNT_ICON = 3;

    const countRestListAssignee = listIdAssignee.length - COUNT_ICON;

    const content = (
        <div style={{ maxHeight: 400, overflow: 'scroll' }}>
            {listIdAssignee.map((userId) => (
                <div key={userId} style={{ marginBottom: 10 }}>
                    <TaskBoardTaskAssignee userId={userId} noDisplayEmptyIcon displayName />
                </div>
            ))}
        </div>
    );

    return (
        <Flex align={'center'}>
            {listIdAssignee.map((userId, index) => {
                if (index < COUNT_ICON) {
                    return <TaskBoardTaskAssignee key={userId} userId={userId} noDisplayEmptyIcon displayHint />;
                }
                return null;
            })}
            {countRestListAssignee > 0 && (
                <Popover content={content} title={'Assignee'} style={{ maxHeight: 350 }}>
                    <span style={{ padding: '0px 10px', fontWeight: 'bold' }}>+{countRestListAssignee}</span>
                </Popover>
            )}
        </Flex>
    );
};

export default ListAssigneeWithAvatar;
